import { notify } from './notifications';

export const handleRefresh = (message: string, msDelay = 2000) => {
	notify({
		type: 'info',
		message,
	});
	setTimeout(() => {
		window.location.reload();
	}, msDelay);
};

export const downloadFileFromS3 = async (downloadUrl: string) => {
	fetch(downloadUrl, {
		headers: {
			'Cache-Control': 'no-cache',
		},
	})
		.then(async (response) => {
			const blob = await response.blob();
			const a = window.document.createElement('a');
			a.href = window.URL.createObjectURL(blob);

			const pathArr = downloadUrl.split('/');
			const fileTitleArr = pathArr[pathArr.length - 1].split('_');

			a.download = fileTitleArr.slice(0, 4).join('-');

			document.body.appendChild(a);
			a.click();

			document.body.removeChild(a);

			return true;
		})
		.catch((err) => {
			console.error(err);
			return false;
		});
};
